import * as actions from 'core/auth/actions';
import React from 'react';
import { connect } from 'react-redux';

interface DispatchPropsInterface {
  signOut: () => void;
}

class SignoutComponent extends React.Component<DispatchPropsInterface> {
  componentDidMount() {
    this.props.signOut();
  }

  componentDidUpdate() {
    this.props.signOut();
  }

  render() {
    return null;
  }
}

export const Signout = connect(
  null,
  actions,
)(SignoutComponent);
